<script setup lang="ts">
interface Props {
  brokerName?: string
  brokerSlug?: string
}

const props = defineProps<Props>()

const content = {
  title: computed(() => `Vraag een offerte aan bij ${props.brokerName || 'Deze makelaar'}`),
  description: computed(
    () =>
      `Ben je op zoek naar een makelaar als ${props.brokerName || 'eeze makelaar'}? Wij helpen je met het vinden van de beste makelaars gespecialiseerd.

.`,
  ),
  features: ['Data-gedreven aanbevelingen', 'Geen verplichtingen', 'Snel & eenvoudig'],
  postcode: {
    label: 'Jouw postcode',
    placeholder: 'bijv. 1234 AB',
  },
  button: 'Vraag offerte aan',
}

const buttonUi = {
  base: 'w-full justify-center cursor-pointer',
}
</script>

<template>
  <div class="bg-gray-50 rounded-xl p-8 mb-8">
    <h2 class="text-2xl font-semibold mb-4">
      {{ content.title }}
    </h2>

    <p class="text-gray-700 mb-6">
      {{ content.description }}
    </p>

    <ul class="space-y-3 mb-8">
      <li
        v-for="feature in content.features"
        :key="feature"
        class="flex items-center"
      >
        <UIcon
          name="i-heroicons-check-circle"
          class="mr-2 text-lg text-gray-700"
        />
        <span class="text-gray-700">{{ feature }}</span>
      </li>
    </ul>

    <UButton
      variant="solid"
      color="primary"
      size="lg"
      :ui="buttonUi"
      :to="`/vergelijk`"
    >
      {{ content.button }}
    </UButton>
  </div>
</template>
